import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-preview-fax",
  templateUrl: "./preview-fax.component.html",
  styleUrls: ["./preview-fax.component.scss"],
})
export class PreviewFaxComponent implements OnInit, OnChanges {
  testSrc = "https://opensource.adobe.com/dc-acrobat-sdk-docs/acrobatsdk/pdfs/acrobatsdk_jsdevguide.pdf";
  blobSrc = "";

  @Input() pdf: Blob | null = null;

  @Output() onPageSubmit = new EventEmitter();
  @Output() navigateBack = new EventEmitter();

  pages = 0;
  activePage = 1;

  constructor() {}

  ngOnInit() {
    if (this.pdf) {
      this.parse(this.pdf);
    }
  }

  ngOnChanges() {
    if (this.pdf) {
      this.parse(this.pdf);
    }
  }

  selectPage(page: number) {
    this.activePage = page;
  }

  parse(file: Blob) {
    this.blobSrc = URL.createObjectURL(file);
  }

  onLoadCompleteSavePagesCount(pages: number) {
    this.pages = pages;
  }

  navigateToPreviousPage() {
    this.navigateBack.emit();
  }

  submitPreview() {
    this.onPageSubmit.emit();
  }
}
